import React from "react"
import { withStyles } from '@material-ui/core';
import { getOrgEvents } from "relay/event"
import { loadProperties } from "relay/common"
import TabBar from "./FilterBar"


const styles = () => ({
  selectedPlaceholder: {
    marginTop: 2,
    fontSize: 14,
  },
  placeholder: {
    color: "rgba(51, 51, 51, 0.75)",
    fontSize: 14,
    marginTop: 2,
    fontWeight: 600
  }
})

const PropertyFilterBar = ({ propertiesOfOrg, firstFilterValue, thirdFilterValue, eventsSelectedByTimeProperties, monthRange, subOrgDetails, handleChangeProperty, handleChangeEvents, handleMonthRange, handleResetClick, classes, ...props }) => {

  React.useEffect(() => {
    if (typeof props.filterSelectedCallback == "function") {
      props.filterSelectedCallback(firstFilterValue, monthRange, thirdFilterValue)
    }
  }, [firstFilterValue, thirdFilterValue, monthRange])

  const getCustomLabelForProperties = (selected, count) => {
    if (firstFilterValue.length == 0) {
      return <div className={classes.placeholder}>Property</div>
    }
    return <div className={classes.selectedPlaceholder}><strong>{firstFilterValue.length < 2 ? "Property" : "Properties"} ({firstFilterValue.length})</strong></div>
  }

  const getCustomLabelForEvents = (selected, count) => {
    if (thirdFilterValue.length == 0) {
      return <div className={classes.placeholder}>Event</div>
    }
    let eventsIds = [];
    for (var i = 0; i < thirdFilterValue.length; i++) {
      eventsIds = [...eventsIds, ...thirdFilterValue[i].list]
    }
    return <div className={classes.selectedPlaceholder}><strong>{eventsIds.length < 2 ? "Event" : "Events"} ({eventsIds.length})</strong></div>
  }
  return (
    <div>
      <TabBar
        firstFilterData={{
          type: "selector",
          optionValue: propertiesOfOrg,
          placeholder: "Property",
          searchPlaceHolder: "Enter property name here...",
          onChange: handleChangeProperty,
          multiple: true,
          singleSelect: false,
          value: firstFilterValue,
          selectAllText: "Select all properties",
          getCustomLabel: getCustomLabelForProperties
        }}
        secondFilterDate={{
          type: "dateRange",
          position: "left",
          value: monthRange,
          handleApply: handleMonthRange,
          timezoneString: subOrgDetails.timezoneString
        }}
        thirdFilterData={{
          type: "selector",
          optionValue: eventsSelectedByTimeProperties,
          placeholder: "Event",
          searchPlaceHolder: "Enter event name here...",
          onChange: handleChangeEvents,
          multiple: true,
          groupBy: true,
          value: thirdFilterValue,
          selectAllText: "Select all Events",
          getCustomLabel: getCustomLabelForEvents
        }}
        handleResetClick={handleResetClick}
        {...props}
      />
    </div>
  )

}
export default withStyles(styles)(PropertyFilterBar)